import ScoringResultsReportPage from './ScoringResultsReportPage';

export default ScoringResultsReportPage;


// WEBPACK FOOTER //
// ./src/features/reports/pages/scoring-results-report-page/index.js